module.exports = __webpack_public_path__ + "img/Dantam Fashion 05.63477d11.jpg";